import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function apiError(e, fallback = "Something went wrong. Please try again.") {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fmtDate = (v) => {
  if (!v) return "Not available";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return String(v);
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

export const fmtDateTime = (v) => {
  if (!v) return "Not available";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return String(v);
  return d.toLocaleString("en-IN", {
    day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
  });
};

export const fmtTime = (v) => {
  if (!v) return "--";
  const d = new Date(v);
  return Number.isNaN(d.getTime())
    ? "--"
    : d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });
};

export const fmtMoney = (v) => {
  if (v === null || v === undefined || v === "") return "Not available";
  const n = Number(v);
  return Number.isNaN(n) ? String(v) : `₹${n.toLocaleString("en-IN")}`;
};

export const fmtLpa = (v) => {
  if (v === null || v === undefined || v === "") return "Not available";
  const n = Number(v);
  return Number.isNaN(n) ? String(v) : `${n} LPA`;
};

export const initials = (name) =>
  (name || "?")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0].toUpperCase())
    .join("");

export const relativeTime = (v) => {
  if (!v) return "";
  const diff = (Date.now() - new Date(v).getTime()) / 1000;
  if (Number.isNaN(diff)) return "";
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return fmtDate(v);
};
